export default __webpack_public_path__ + "static/media/3.3d3d9aa2.png";